import { CoordinateApiModel } from '../coordinate.api-model';
import { ServiceJourneyDetailsApiModel } from './service-journey-details.api-model';
import { CallDetailsApiModel } from './call-details.api-model';
import type { ITripLegDetails } from '../../../../models/trip-leg-details.model';

export class TripLegDetailsApiModel {
  public static mapToBusinessModel(apiModel: TripLegDetailsApiModel): ITripLegDetails {
    return {
      serviceJourneys: apiModel.serviceJourneys ? apiModel.serviceJourneys.map(ServiceJourneyDetailsApiModel.mapToBusinessModel) : undefined,
      callsOnTripLeg: apiModel.callsOnTripLeg ? apiModel.callsOnTripLeg.map(CallDetailsApiModel.mapToBusinessModel) : undefined,
      tripLegCoordinates: apiModel.tripLegCoordinates ? apiModel.tripLegCoordinates.map(CoordinateApiModel.mapToBusinessModel) : undefined,
      isCancelled: apiModel.isCancelled,
      isPartCancelled: apiModel.isPartCancelled,
      journeyLegIndex: apiModel.journeyLegIndex,
    };
  }

  public serviceJourneys!: ServiceJourneyDetailsApiModel[];
  public callsOnTripLeg!: CallDetailsApiModel[];
  public tripLegCoordinates?: CoordinateApiModel[];
  public isCancelled!: boolean;
  public isPartCancelled!: boolean;
  public journeyLegIndex!: number;
}
